import { equals } from 'ramda';

import { TJsonQuery } from '../../../../../packages/JsonQuery';
import { getJsonQueryWithoutRequestOnlyTerms } from '../getJsonQueryWithoutRequestOnlyTerms';

// Сортировка меняет порядок выдачи, а не набор объектов - условием поиска не считается
const ORDER_ONLY_TERMS = new Set(['sort']);

function getSearchConditions(jsonQuery: TJsonQuery): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(getJsonQueryWithoutRequestOnlyTerms(jsonQuery)).filter(
      // resetTerms и setTerm(null) оставляют `key: undefined`, а ramda equals отличает его от отсутствия ключа
      ([key, value]) => value !== undefined && !ORDER_ONLY_TERMS.has(key),
    ),
  );
}

/**
 * Условия поиска совпадают: запросы отличаются максимум страницей, ids листинга или сортировкой.
 */
export function isSameSearch(jsonQuery: TJsonQuery, otherJsonQuery: TJsonQuery): boolean {
  return equals(getSearchConditions(jsonQuery), getSearchConditions(otherJsonQuery));
}
